var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 60c0 27.614 22.386 50 50 50a50 50 0 0050-50c0-27.614-22.386-50-50-50S10 32.386 10 60zm9.082 0c0-22.593 18.316-40.91 40.91-40.91C82.584 19.09 100.9 37.408 100.9 60c0 22.593-18.315 40.909-40.909 40.909-22.593 0-40.909-18.316-40.909-40.909zm15.959 3.54l17.82 17.82 32.105-32.11a4.994 4.994 0 000-7.07 4.994 4.994 0 00-7.07 0L52.86 67.22 42.11 56.463a5 5 0 10-7.07 7.075z",
    fill: "#00D8AE"
  })));
}

export default "data:image/svg+xml,%3Csvg width='120' height='120' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M10 60c0 27.614 22.386 50 50 50a50 50 0 0 0 50-50c0-27.614-22.386-50-50-50S10 32.386 10 60zm9.082 0c0-22.593 18.316-40.91 40.91-40.91C82.584 19.09 100.9 37.408 100.9 60c0 22.593-18.315 40.909-40.909 40.909-22.593 0-40.909-18.316-40.909-40.909zm15.959 3.54 17.82 17.82 32.105-32.11a4.994 4.994 0 0 0 0-7.07 4.994 4.994 0 0 0-7.07 0L52.86 67.22 42.11 56.463a5 5 0 1 0-7.07 7.075z' fill='%2300D8AE'/%3E %3C/svg%3E";
export { SvgIcCheckbox as ReactComponent };